import { Typography, Card, ChevronRightIcon, useToast, LoadingToast } from "@fanka/ui-admin";
import { DepartmentsPageProps } from "@on-site/components/pages/directVisit/ui/departments/type";
import { useLocalViewsStore } from "@on-site/features/top/hooks/useLocalViewsStore";
import { GoBackViewButton } from "@on-site/features/top/ui/GoBackViewButton";

import { useClinicParams } from "@on-site/hooks/useClinicParams";
import { PageLayout } from "@on-site/layouts/PageLayout";

import { useAppApiSWR } from "@on-site/libs/swr/useAppApiSWR";

export const DepartmentsPage = ({ onSelectDepartment }: DepartmentsPageProps) => {
  const { setLocalView } = useLocalViewsStore();

  const { clinicId } = useClinicParams();
  const { openToast } = useToast();

  const { data, isLoading } = useAppApiSWR("/api/v2/public/clinics/{clinicId}/departments/direct-visit", {
    params: {
      path: {
        clinicId,
      },
    },
    onSuccess: ({ departments }) => {
      // NOTE: 診療科が一つの場合は選択をスキップ
      if (!!departments && departments.length === 1) {
        onSelectDepartment(departments[0]);
      }
    },
    onError: (error) => {
      openToast({ type: "error", description: error?.message });
    },
  });

  if (isLoading || data?.departments.length === 1) return <LoadingToast isLoading />;

  return (
    <PageLayout leftTopButton={<GoBackViewButton onClick={() => setLocalView("DEFAULT")} />}>
      <div className="mx-auto flex h-full w-full max-w-[928px] flex-col items-center justify-center gap-y-12 px-6">
        <div className="flex flex-col items-center gap-y-6">
          <div className="bg-grayScale-500 text-ui-white w-fit rounded-[5px] px-2.5 py-1">
            <Typography.UiText size="lg" bold>
              当日受付でのご案内
            </Typography.UiText>
          </div>
          <Typography.Heading type="h1">診療科をお選びください</Typography.Heading>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {data?.departments.map((department) => (
            <section className="w-[282px]">
              <Card onClick={() => onSelectDepartment(department)}>
                <div className="flex items-center justify-between">
                  <Typography.UiText size="lg" bold>
                    {department.name}
                  </Typography.UiText>
                  <ChevronRightIcon height={24} width={24} className="fill-grayScale-300" />
                </div>
              </Card>
            </section>
          ))}
        </div>
      </div>
    </PageLayout>
  );
};
